import React from 'react';
import styled from 'styled-components';

const EducationContainer = styled.div`
  padding: 30px;
  font-family: 'Ubuntu', sans-serif;
  color: #00ff00;
  background: rgba(0, 0, 0, 0.9);
  height: 100%;
  overflow-y: auto;
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 30px;
  border-bottom: 2px solid #00ff00;
  padding-bottom: 20px;
`;

const Title = styled.h1`
  color: #00ffff;
  margin-bottom: 10px;
`;

const Timeline = styled.div`
  position: relative;
  padding-left: 30px;

  &::before {
    content: '';
    position: absolute;
    left: 15px;
    top: 0;
    bottom: 0;
    width: 2px;
    background: #00ff00;
  }
`;

const TimelineItem = styled.div`
  position: relative;
  margin-bottom: 30px;
  background: rgba(0, 255, 0, 0.1);
  border: 1px solid rgba(0, 255, 0, 0.3);
  border-radius: 8px;
  padding: 20px;
  margin-left: 20px;

  &::before {
    content: '';
    position: absolute;
    left: -35px;
    top: 20px;
    width: 12px;
    height: 12px;
    background: #00ff00;
    border-radius: 50%;
    border: 2px solid #000;
  }
`;

const Institution = styled.h3`
  color: #00ffff;
  margin-bottom: 5px;
`;

const Degree = styled.h4`
  color: #ffff00;
  margin-bottom: 10px;
`;

const Duration = styled.div`
  color: #cccccc;
  font-style: italic;
  margin-bottom: 15px;
`;

const Location = styled.div`
  color: #cccccc;
  margin-bottom: 15px;
`;

const Description = styled.p`
  line-height: 1.6;
  margin-bottom: 15px;
`;

const Achievements = styled.ul`
  list-style: none;
  padding: 0;
`;

const Achievement = styled.li`
  margin-bottom: 8px;
  padding-left: 20px;
  position: relative;

  &::before {
    content: '🏆';
    position: absolute;
    left: 0;
  }
`;

const EducationSystem: React.FC = () => {
  const educationData = [
    {
      institution: 'Army Institute of Technology (AIT)',
      degree: 'Bachelor of Engineering in Computer Science',
      duration: 'Aug. 2023 – June 2027 (Expected)',
      location: 'Pune, Maharashtra',
      description: 'Pursuing comprehensive computer science education with specialization in cybersecurity and software development.',
      achievements: [
        'Joint Secretary, Information Security & Digital Forensics (ISDF) Club',
        'Organizing cybersecurity workshops and CTF events',
        'Leading student initiatives in ethical hacking and digital forensics',
        'Mentoring junior students in cybersecurity concepts'
      ]
    }
  ];

  const certifications = [
    {
      name: 'Top 1% in TryHackMe Platform',
      issuer: 'TryHackMe',
      date: '2024',
      description: 'Achieved top 1% ranking among global cybersecurity practitioners'
    },
    {
      name: 'IoT Security Specialist',
      issuer: 'Copper Cloud IOTech Pvt Ltd',
      date: '2025',
      description: 'Completed intensive training in IoT security for Industry 4.0 applications'
    }
  ];

  return (
    <EducationContainer>
      <Header>
        <Title>🎓 Education System Log</Title>
        <p>Academic journey and professional development</p>
      </Header>

      <Timeline>
        {educationData.map((edu, index) => (
          <TimelineItem key={index}>
            <Institution>{edu.institution}</Institution>
            <Degree>{edu.degree}</Degree>
            <Duration>{edu.duration}</Duration>
            <Location>📍 {edu.location}</Location>
            <Description>{edu.description}</Description>
            <Achievements>
              {edu.achievements.map((achievement, achIndex) => (
                <Achievement key={achIndex}>{achievement}</Achievement>
              ))}
            </Achievements>
          </TimelineItem>
        ))}

        <TimelineItem>
          <Institution>Professional Certifications</Institution>
          {certifications.map((cert, certIndex) => (
            <div key={certIndex} style={{ marginBottom: '15px' }}>
              <Degree>{cert.name}</Degree>
              <Duration>{cert.issuer} - {cert.date}</Duration>
              <Description>{cert.description}</Description>
            </div>
          ))}
        </TimelineItem>
      </Timeline>
    </EducationContainer>
  );
};

export default EducationSystem;
